module.exports = __webpack_public_path__ + "img/icon-dot-blue.50282aa6.svg";